export function initializeSignupFormHandler() {
  const pathname = window.location.pathname;
  
  if (pathname === '/') {
    // skip if it's the home page
    return;
  }

  // Find all forms that need source tracking
  const signupForms = document.querySelectorAll('.signup-form-with-source');
  
  signupForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const sourceValue = pathname.substring(1);

      if (sourceValue !== '') {
        const sourceInput = document.createElement('input');
        sourceInput.type = 'hidden';
        sourceInput.name = 'source';
        sourceInput.value = sourceValue;
        form.appendChild(sourceInput);
      }

      form.submit();
    });
  });
}
